import { H6 } from "@sellar-io/components";
import { useMediaQuery } from "usehooks-ts";
import { useShallow } from "zustand/react/shallow";

import { DiscoveryFilterButton } from "../components/DiscoveryFilterButton";
import { FilterDrawerHeader } from "../components/DiscoveryMobileFilterDrawer";
import {
  abvFilterType,
  AbvType,
  useDiscoveryV2SearchStore,
} from "../DiscoveryV2SearchStore";
import { CollapsableFilterCard } from "./FilterCard";

export const FilterAbvCard = ({ onClick }: { onClick?: () => void }) => {
  const isDesktop = useMediaQuery("(min-width: 1084px)");
  const { selectedAbvTypes, removeAbvType, addAbvType } =
    useDiscoveryV2SearchStore(
      useShallow((state) => ({
        selectedAbvTypes: state.selectedAbvTypes,
        addAbvType: state.addAbvType,
        removeAbvType: state.removeAbvType,
      })),
    );

  const onItemClick = (abvTypeKey: AbvType) => {
    if (selectedAbvTypes.includes(abvTypeKey)) {
      return removeAbvType(abvTypeKey);
    }
    addAbvType(abvTypeKey as AbvType);
  };
  return (
    <>
      {isDesktop ? (
        <CollapsableFilterCard header={<H6>ABV</H6>}>
          {Object.keys(abvFilterType).map((abvTypeKey) => (
            <DiscoveryFilterButton
              key={abvTypeKey}
              selected={selectedAbvTypes.includes(abvTypeKey)}
              onClick={() => onItemClick(abvTypeKey as AbvType)}
              title={abvFilterType[abvTypeKey as AbvType].name}
            />
          ))}
        </CollapsableFilterCard>
      ) : (
        <div className={"flex flex-col"}>
          <FilterDrawerHeader title={"ABV"} onClick={onClick} />
          <div className={"mt-4 flex flex-col gap-1 p-4"}>
            {Object.keys(abvFilterType).map((abvTypeKey) => (
              <DiscoveryFilterButton
                key={abvTypeKey}
                selected={selectedAbvTypes.includes(abvTypeKey)}
                title={abvFilterType[abvTypeKey as AbvType].name}
                onClick={() => onItemClick(abvTypeKey as AbvType)}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};
